const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const presentAbsent = (value, t) => {
  const map = {
    present: t('Presente'),
    absent: t('Assente'),
  };
  return display(map[value] || value);
};

const statusLabel = (value, t) => {
  const map = {
    void: t('void'),
    open: t('open'),
    in_asset: t('in_asset'),
  };
  return display(map[value] || value);
};

const finishLabel = (value, t) => {
  const map = {
    rustic: t('Rustico'),
    fake: t('Finita'),
  };
  return display(map[value] || value);
};

export const getRoomViewSections = (t, item, companies = []) => {
  if (!item?.id) {
    return [];
  }

  const companyTitle =
    item.company?.title ||
    companies.find((c) => String(c.value) === String(item.company_id))?.title;

  return [
    {
      title: t('UNITA'),
      fields: [
        {
          text: t('Asset di riferimento'),
          value: display(item.leasings_asset?.title || item.leasings_asset),
        },
        { text: t('Stato unità'), value: statusLabel(item.status, t) },
        { text: t('Insegna'), value: display(companyTitle) },
        { text: `${t('Note')} (${t('Insegna')})`, value: display(item.company_note) },
        { text: t('Unità'), value: display(item.title) },
        { text: t('Impianto a/c'), value: presentAbsent(item.plant_ac, t) },
        {
          text: `${t('Note')} (${t('Impianto a/c')})`,
          value: display(item.plant_ac_note),
        },
        { text: t('GLA'), value: display(item.gla) },
        {
          text: t('Impianto luci'),
          value: presentAbsent(item.plant_lights, t),
        },
        {
          text: `${t('Note')} (${t('Impianto luci')})`,
          value: display(item.plant_lights_note),
        },
        { text: t('Quota minima stock'), value: display(item.sales_area) },
        {
          text: t('Antitaccheggio'),
          value: presentAbsent(item.plant_anti_theft, t),
        },
        {
          text: `${t('Note')} (${t('Antitaccheggio')})`,
          value: display(item.plant_anti_theft_note),
        },
        { text: t('Finitura'), value: finishLabel(item.finish, t) },
        { text: t('Arredo'), value: presentAbsent(item.furniture, t) },
        {
          text: `${t('Note')} (${t('Arredo')})`,
          value: display(item.furniture_note),
        },
        { text: t('Bagno'), value: presentAbsent(item.wc, t) },
        {
          text: `${t('Note')} (${t('Bagno')})`,
          value: display(item.wc_note),
        },
      ],
    },
  ];
};
